export default "__VITE_ASSET__fSDftT31__"